import React from 'react';

const Footer = () => {
  return (
    <div className="p-6 mt-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">
        Generated on {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} | Salesforce Technical Architect Review
      </p>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">
        This evaluation is based on comprehensive Salesforce quality checklist covering 18 categories with 200+ requirements.
      </p>
      <p className="text-sm text-gray-500 dark:text-gray-400">
        <span className="font-semibold">Overall Assessment:</span> This is an exemplary Salesforce sample application demonstrating excellent LWC practices, modern development tooling, and strong attention to accessibility and user experience. With minor enhancements to testing coverage and documentation, this could serve as a production-ready template.
      </p>
    </div>
  );
};

export default Footer;
